module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-tab"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBranchCompany),
      expression: "isBranchCompany"
    }],
    staticClass: "form",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分部名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入分部名称"
    },
    model: {
      value: (_vm.CompanySearch.Name),
      callback: function($$v) {
        _vm.CompanySearch.Name = $$v
      },
      expression: "CompanySearch.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "options": _vm.Provinces,
      "clearable": "",
      "props": {
        value: 'Id',
        label: 'Name',
        children: 'children'
      },
      "placeholder": "请选择办事处（省/市/区）"
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.CompanySearch.Place),
      callback: function($$v) {
        _vm.CompanySearch.Place = $$v
      },
      expression: "CompanySearch.Place"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "background": "#20a0ff",
      "width": "120px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.regionLoading
    },
    on: {
      "click": _vm.getRegion
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-button', {
    class: ['btn', _vm.isBranchCompany ? '' : 'active'],
    on: {
      "click": function($event) {
        _vm.handleTabClick({
          flag: 'zongbu'
        })
      }
    }
  }, [_vm._v("总部信息")]), _vm._v(" "), _c('el-button', {
    class: ['btn', _vm.isBranchCompany ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.handleTabClick({
          flag: 'fenbu'
        })
      }
    }
  }, [_vm._v("分部信息")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn002",
    on: {
      "click": function($event) {
        _vm.handleBranchCompanyDialogOpen()
      }
    }
  }, [_vm._v("新增分部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBranchCompany),
      expression: "!isBranchCompany"
    }],
    staticClass: "card"
  }, [_c('h4', [_vm._v(_vm._s(_vm.Company.CardName))]), _vm._v(" "), _c('el-form', {
    staticClass: "form",
    attrs: {
      "label-width": "110px",
      "label-suffix": "：",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司地址"
    }
  }, [_vm._v(_vm._s(_vm.Company.ProvinceName) + _vm._s(_vm.Company.CityName) + _vm._s(_vm.Company.AreaName) + _vm._s(_vm.Company.Address))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(_vm._s(_vm.Company.Phone))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司邮箱"
    }
  }, [_vm._v(_vm._s(_vm.Company.Email))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司QQ"
    }
  }, [_vm._v(_vm._s(_vm.Company.QQ))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司微信"
    }
  }, [_vm._v(_vm._s(_vm.Company.WeChat))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司传真"
    }
  }, [_vm._v(_vm._s(_vm.Company.Fax))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司开票代码"
    }
  }, [_vm._v(_vm._s(_vm.Company.InvoiceCode))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公司网址"
    }
  }, [_vm._v(_vm._s(_vm.Company.CardUrl))])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-area",
    staticStyle: {
      "top": "6px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleCompanyDialogOpen
    }
  }, [_vm._v("编辑")])], 1)], 1), _vm._v(" "), (_vm.isBranchCompany) ? _vm._l((_vm.BranchCompanys), function(BranchCompany) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.regionLoading),
        expression: "regionLoading"
      }],
      key: BranchCompany.Id,
      staticClass: "card",
      attrs: {
        "element-loading-text": "加载中"
      }
    }, [_c('el-form', {
      staticClass: "form",
      staticStyle: {
        "margin-top": "0"
      },
      attrs: {
        "label-width": "110px",
        "label-suffix": "：",
        "label-position": "right"
      }
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "分部名称"
      }
    }, [_vm._v(_vm._s(BranchCompany.Name))]), _vm._v(" "), _c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "分部地址"
      }
    }, [_vm._v(_vm._s(BranchCompany.Province && BranchCompany.Province.Name) + " " + _vm._s(BranchCompany.City && BranchCompany.City.Name) + " " + _vm._s(BranchCompany.County && BranchCompany.County.Name) + " " + _vm._s(BranchCompany.Address))]), _vm._v(" "), _c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "分部联系方式"
      }
    }, [_vm._v(_vm._s(BranchCompany.MobilePhone))])], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-area"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.handleBranchCompanyDialogOpen(BranchCompany)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
      staticClass: "danger",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.handleRemoveBranchCompany(BranchCompany)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }) : _vm._e()], 2), _vm._v(" "), _c('company-dialog', {
    attrs: {
      "form": _vm.Dialog.form,
      "show": _vm.Dialog.show
    },
    on: {
      "update:show": function($event) {
        _vm.Dialog.show = $event
      },
      "confirm": _vm.handleConfirm
    }
  }), _vm._v(" "), _c('branch-company-dialog', {
    attrs: {
      "form": _vm.BranchDialog.form,
      "show": _vm.BranchDialog.show
    },
    on: {
      "update:show": function($event) {
        _vm.BranchDialog.show = $event
      },
      "confirm": _vm.handleBranchConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6e4ccfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/CompanyTab.vue
// module id = 774
// module chunks = 0